<template>
    <div>
        <loader v-if="loading" />
        <v-row v-else>
            <v-col>
                <v-card>
                    <v-card-text>
                        <v-subheader>
                            <v-row>
                                <v-col>
                                    Navn
                                </v-col>
                                <v-col>
                                    Emne ID
                                </v-col>
                                <v-col>
                                    Dato
                                </v-col>
                                <v-col>
                                    Funktioner
                                </v-col>
                            </v-row>
                        </v-subheader>
                        <v-list class="striped-list">
                            <v-list-item v-for="commonRedial in commonRedials" :key="commonRedial.uniqueId">
                                <v-row align="center">
                                    <v-col>
                                        {{ commonRedial.agentName }}
                                    </v-col>
                                    <v-col>
                                        {{ commonRedial.leadUniqueId }}
                                    </v-col>
                                    <v-col>
                                        {{ commonRedial.date }}
                                    </v-col>
                                    <v-col class="text-right">
                                        <div class="d-flex">
                                            <v-btn icon :href="$hbLeadLink(commonRedial.leadUniqueId)" target="_blank">
                                                <v-icon>fa-eye</v-icon>
                                            </v-btn>
                                            <v-btn icon @click="toggleForwarded(commonRedial)" :color="commonRedial.forwarded ? 'primary' : 'grey'">
                                                <v-icon v-model="commonRedial.forwarded">fa-envelope</v-icon>
                                            </v-btn>
                                            <v-btn icon @click="toggleClosed(commonRedial)" :color="commonRedial.closed ? 'primary' : 'grey'">
                                                <v-icon v-model="commonRedial.closed">fa-times</v-icon>
                                            </v-btn>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    data () {
        return {
            loading: true,
            commonRedials: null
        }
    },
    methods: {
        async toggleForwarded (commonRedial) {
            commonRedial.forwarded = !commonRedial.forwarded
            await this.$http().post('processing/commonRedials', commonRedial)
        },
        async toggleClosed (commonRedial) {
            commonRedial.closed = !commonRedial.closed
            await this.$http().post('processing/commonRedials', commonRedial)
        },
        async getData () {
            this.loading = true
            const response = await this.$http().get('processing/commonRedials')
            this.commonRedials = response.data
            this.loading = false
        }
    },
    created () {
        this.getData()
    }
}
</script>